import { Link } from 'react-router-dom';

import { ROUTE_KNM_FROM_ANALYTICS_ID, ROUTE_PM_FROM_ANALYTICS__ID } from 'CorePackage/MainModule/routes/routes';
import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';

import styles from './KnmListRenderErpId.module.scss';

interface IKnmListErpId {
  id: string | number;
}

export function AnalyticsKnmListRenderErpId<T extends IKnmListErpId>({
  value,
  row,
  isPm,
  isTest,
}: ITableRenderCell<T>) {
  return (
    <div className={styles.ErpIdCellWrapper}>
      <Link
        className="shared-table-link"
        to={isPm ? ROUTE_PM_FROM_ANALYTICS__ID(row.id) : ROUTE_KNM_FROM_ANALYTICS_ID(row.id)}
        target="_blank"
        rel="noopener noreferrer"
      >
        {value}
      </Link>
      {isTest && <span className={styles.TestUserWrapper}>ТЕСТ</span>}
    </div>
  );
}
